export function isWithinFourDays(
  similarPressDate: string,
  targetPressDate: string,
): boolean {
  const similarDate = new Date(similarPressDate);
  const targetDate = new Date(targetPressDate);
  const diffInDays: number = Math.abs(
    (targetDate.getTime() - similarDate.getTime()) / (1000 * 60 * 60 * 24),
  );
  return diffInDays <= 4;
}
